import React, { useState } from 'react';
import './index.less';
import { Progress, Radio } from 'antd';
import ActiveStage from '../active-stage';
import ResumptionPeriod from '../resumption-period';
import moment from 'moment';
import './index.less';

const ActivityDetail = (props) => {
  const {
    planCode,
    planName,
    activityStartTime,
    activityEndTime,
    activityStatus,
    planPercent,
    gotoAllActivity,
  } = props;
  const [position, setPosition] = useState(activityStatus === '1' ? '2' : '1');
  console.log('活动状态', activityStatus);
  console.log('解析时间', moment(activityStartTime).valueOf());

  return (
    <>
      <div className="participant-data-detail-card-bg">
        <div style={{ display: 'flex' }}>
          <div
            onClick={() => gotoAllActivity()}
            style={{
              color: 'rgba(0, 0, 0, 0.65)',
              fontWeight: '400',
              fontSize: '14px',
              marginBottom: '14px',
              cursor: 'pointer',
            }}
          >
            &lt; 返回全部活动
          </div>
        </div>

        <div className="participant-act-detail-header">
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <div className="participant-act-detail-header-title">{planName || ''}</div>
            {activityStartTime && activityEndTime && (
              <div className="participant-act-detail-header-subtitle">
                活动时间:{activityStartTime}~{activityEndTime}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            <div className={'act-status-text' + (activityStatus === '1' || activityStatus === '0' ? ' end' : '')}>
              {activityStatus === '1' ? '已结束' : activityStatus === '0' ? '未开始' : '进行中'}
            </div>
            <div style={{ width: '427px', marginLeft: '7px' }}>
              <Progress
                percent={planPercent}
                showInfo={false}
                trailColor="#D8D8D8"
                strokeColor={{
                  '0%': '#FFFFFF',
                  '100%': '#45D190',
                }}
              />
            </div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <Radio.Group
              onChange={(ev) => {
                setPosition(ev.target.value);
              }}
              value={position}
            >
              <Radio.Button value="1">活动期</Radio.Button>
              <Radio.Button value="2" disabled={activityStatus !== '1'}>
                复盘期
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
      </div>
      {position === '1' && (
        <ActiveStage
          activityStatus={activityStatus}
          activityStartTime={activityStartTime}
          activityEndTime={activityEndTime}
          planCode={planCode}
        />
      )}
      {position === '2' && (
        <ResumptionPeriod
          activityStatus={activityStatus}
          activityStartTime={activityStartTime}
          activityEndTime={activityEndTime}
          planCode={planCode}
        />
      )}
    </>
  );
};
export default ActivityDetail;
